import { Link } from "react-router-dom";
import { imgUrl } from "@/lib/api";

export const Logo = ({ compact = false }) => (
  <Link to="/" data-testid="site-logo" className="flex items-center gap-3">
    <img src={imgUrl("/api/files/bookedbybenj/site/bb-logo.png")} alt="Booked By Benj"
      className="h-9 w-auto" />
    {!compact && (
      <span className="hidden sm:block text-[10px] font-medium tracking-[0.35em] text-zinc-400 uppercase">
        Booked by Benj
      </span>
    )}
  </Link>
);
